import {
  EncounterInvalidateReasonCode,
  encounterInvalidateReasonCodeDisplay,
} from '@quromedical/fhir-common';
import { CrudForm } from 'components/form';
import { Field } from 'components/types';
import React from 'react';
import { strings } from 'strings';
import { z } from 'zod';

const AdmissionInvalidateReasonSchema = z.object({
  statusReason: z.nativeEnum(EncounterInvalidateReasonCode),
});
type AdmissionInvalidateReason = z.infer<typeof AdmissionInvalidateReasonSchema>;

export interface AdmissionInvalidateReasonProps {
  onChange?: (data: AdmissionInvalidateReason) => void;
}

const invalidateReasons: EncounterInvalidateReasonCode[] = Object.values(
  EncounterInvalidateReasonCode
);

type MapEncounterInvalidateReasons = { display: string; value: EncounterInvalidateReasonCode };

const mapEncounterInvalidateReasons = (): MapEncounterInvalidateReasons[] => {
  return invalidateReasons.map(reason => ({
    display: encounterInvalidateReasonCodeDisplay[reason],
    value: reason,
  }));
};

const reasonField: Field<AdmissionInvalidateReason> = {
  subfields: [
    {
      key: 'statusReason',
      type: 'combobox-single',
      label: strings.AdmissionInvalidateReasonLabel,
      fetcher: mapEncounterInvalidateReasons(),
    },
  ],
};

export const AdmissionInvalidateReason: React.FC<AdmissionInvalidateReasonProps> = ({
  onChange,
}) => {
  return (
    <CrudForm
      fields={[reasonField]}
      initialValues={{}}
      showSubmitButton={false}
      onChange={onChange}
      validationSchema={AdmissionInvalidateReasonSchema}
      cardProps={{ unsetZIndex: true }}
      hasCard={false}
      onChangeDebounceTime={0}
    />
  );
};
